import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    icon: 'uil-home-alt',
    link: '/',
  },
  {
    id: 22,
    label: 'MENUITEMS.APPS.TEXT',
    icon: 'uil-apps',
    subItems: [
      {
        id: 23,
        label: 'MENUITEMS.PAYMENTCENTER.TEXT',
        link: '/cell-payment-service',
      },
    ],
  },
  {
    id: 59,
    label: 'MENUITEMS.REPORTS.TEXT',
    icon: 'uil-layers',
    subItems: [
      {
        id: 60,
        label: 'MENUITEMS.REPORSTUSER.TEXT',
      },
    ],
  },
  {
    id: 93,
    label: 'MENUITEMS.UTILITY.TEXT',
    icon: 'bx-file',
    subItems: [
      {
        id: 94,
        label: 'MENUITEMS.UTILITY.LIST.STARTER',
        link: '/pages/starter',
        parentId: 93,
      },
      {
        id: 95,
        label: 'MENUITEMS.UTILITY.LIST.MAINTENANCE',
        link: '/pages/maintenance',
        parentId: 93,
      },
      {
        id: 96,
        label: 'MENUITEMS.UTILITY.LIST.COMINGSOON',
        link: '/pages/comingsoon',
        parentId: 93,
      },
      {
        id: 96,
        label: 'MENUITEMS.UTILITY.LIST.TIMELINE',
        link: '/pages/timeline',
        parentId: 93,
      },
      {
        id: 97,
        label: 'MENUITEMS.UTILITY.LIST.FAQS',
        link: '/pages/faqs',
        parentId: 93,
      },
      {
        id: 98,
        label: 'MENUITEMS.UTILITY.LIST.PRICING',
        link: '/pages/pricing',
        parentId: 93,
      },
      {
        id: 99,
        label: 'MENUITEMS.UTILITY.LIST.ERROR404',
        link: '/pages/404',
        parentId: 93,
      },
      {
        id: 100,
        label: 'MENUITEMS.UTILITY.LIST.ERROR500',
        link: '/pages/500',
        parentId: 93,
      },
    ],
  },
];
